/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InsightsFormatPricingSchemaFormat } from './insightsFormatPricingSchemaFormat';

/**
 * Per-format price of an Insights export.
 */
export interface InsightsFormatPricingSchema {
  format: InsightsFormatPricingSchemaFormat;
  credits: number;
}
